<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                small
                fab
                text
            >
                <v-icon dark>
                    mdi-menu
                </v-icon>
            </v-btn>
        </template>
        <v-list>
            <v-list-item
                v-for="(item, index) in items"
                :key="index"
                @click="emitEvent(item.value)"
            >
                <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import SmartNavMaker from "@/SmartNav/SmartNavMaker";

export default {
    name: "SmartNavItemBurgerMenu",
    data() {
        return {
            items: [
                { value: 'NEW', text: 'New Child' },
                { value: 'DELETE', text: 'Delete' },
            ],
        }
    },
    methods: {
        emitEvent(event_name) {
            this.$emit(event_name)
        },
    },
}
</script>

<style>

</style>
